import { MathFunctions } from '@zeainc/zea-engine'
/**
 * Update a given avatar opacity when it gets too close to camera.
 *
 * @param {Avatar} avatar - the avatar that will get its opacity modified.
 * @param {Xfo} viewXfo - the avatar view xfo used to measure distance from camera.
 * @param {Camera} camera - current user's camera.
 */
export const adjustAvatarOpacity = (avatar, viewXfo, camera) => {
  const distanceToUser = camera.globalXfoParam.value.tr.distanceTo(viewXfo.tr)
  const avatarRadius = 0.4 * avatar.avatarScale
  const buffer = 1.5 * avatarRadius
  const fadeDistance = avatarRadius + buffer
  if (distanceToUser <= fadeDistance) {
    const distanceOpacity = MathFunctions.smoothStep(avatarRadius, fadeDistance, distanceToUser)
    avatar.treeItem.opacityParam.value = distanceOpacity
  } else {
    avatar.treeItem.opacityParam.value = 1
  }
}
